import { render, staticRenderFns } from "./HasilSidangBerdasarkanStatus.vue?vue&type=template&id=10158032"
import script from "./HasilSidangBerdasarkanStatus.vue?vue&type=script&lang=js"
export * from "./HasilSidangBerdasarkanStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports